import Program from "pages/dashboard/shared/TestManger/Program";
import { FC } from "react";

interface AdminTestProgramProps {}

const AdminTestProgram: FC<AdminTestProgramProps> = () => {
  return <Program />;
};
export default AdminTestProgram;
